module.exports = __webpack_public_path__ + "img/scene5-13.8d6ffa7f.png";